import jwt from '@src/auth/jwt/useJwt'

export const fetchBroadcastUsersTableApi = async ({ email = '', limit = 20, offset = 0, userId }) => {
  try {
    const response = await jwt.get('admin/broadcast/users', {
      params: { email, limit, offset },
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('No tenés permisos de admin')
      err.type = 'FORBIDDEN'
      throw err
    }
    throw new Error('Error al obtener usuarios')
  }
}

export const searchBroadcastUsersApi = async ({ email, limit = 20, userId }) => {
  try {
    const response = await jwt.get('admin/broadcast/users', {
      params: { email, limit },
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('Forbidden')
      err.type = 'FORBIDDEN'
      throw err
    }
    const err = new Error('Error al buscar usuarios')
    err.type = 'SERVER_ERROR'
    throw err
  }
}

export const fetchBroadcastMessagesApi = async ({ limit = 20, offset = 0, userId }) => {
  try {
    const response = await jwt.get('admin/broadcast/messages', {
      params: { limit, offset },
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('No tenés permisos de admin')
      err.type = 'FORBIDDEN'
      throw err
    }
    throw new Error('Error al obtener mensajes')
  }
}

export const fetchBroadcastMessageRecipientsApi = async ({ id, limit = 50, offset = 0, userId }) => {
  try {
    const response = await jwt.get(`admin/broadcast/messages/${id}/recipients`, {
      params: { limit, offset },
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('No tenés permisos de admin')
      err.type = 'FORBIDDEN'
      throw err
    }
    throw new Error('Error al obtener destinatarios')
  }
}

export const fetchBroadcastMessageStatsApi = async ({ id, userId }) => {
  try {
    const response = await jwt.get(`admin/broadcast/messages/${id}/stats`, {
      headers: { UserId: userId }
    })
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('No tenés permisos de admin')
      err.type = 'FORBIDDEN'
      throw err
    }
    throw new Error('Error al obtener estadísticas del mensaje')
  }
}

export const sendBroadcastApi = async ({ subject, body, important, notification_summary, recipients, userId }) => {
  try {
    const payload = { subject, body, important, recipients }
    if (notification_summary) payload.notification_summary = notification_summary

    const response = await jwt.post(
      'admin/broadcast/message',
      payload,
      { headers: { UserId: userId } }
    )
    return response.data
  } catch (error) {
    const status = error?.response?.status
    if (status === 403) {
      const err = new Error('Forbidden')
      err.type = 'FORBIDDEN'
      throw err
    }
    if (status === 400) {
      const message = error?.response?.data?.error || 'Parámetros inválidos'
      const err = new Error(message)
      err.type = 'BAD_REQUEST'
      throw err
    }
    const err = new Error(`Error del servidor: ${status || 'unknown'}`)
    err.type = 'SERVER_ERROR'
    throw err
  }
}
